import { Box, Grid, Skeleton } from "@mui/material";

import styled from "@emotion/styled";

export default function HistoryWithdrawSkeleton({ heightSize }) {
  return (
    <Grid container spacing={2}>
      <Grid xs={12} item>
        <Box>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>

      <Grid xs={12} item>
        <Box>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>

      <Grid xs={12} item>
        <Box>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>

      <Grid xs={12} item>
        <Box>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>

      <Grid xs={12} item>
        <Box>
          <SkeletonStyle
            variant="rounded"
            height={heightSize}
            width="100%"
          ></SkeletonStyle>
        </Box>
      </Grid>
    </Grid>
  );
}

const SkeletonStyle = styled(Skeleton)(() => ({
  borderRadius: "10px",
  height: "90px",
}));
